
















import Vue from "vue";

const levelMap = {
  0: "n",
  n: "n",
  1: "l",
  l: "l",
  2: "m",
  m: "m",
  3: "h",
  h: "h",
};

const severityMap = {
  0: "No severity",
  n: "No severity",
  1: "Low severity",
  l: "Low severity",
  2: "Medium severity",
  m: "Medium severity",
  3: "High severity",
  h: "High severity",
};

export default Vue.extend({
  props: ["level"],
  setup() {
    return {
      levelMap,
      severityMap,
    };
  },
});
